const SEPARATOR = ".";
const NAME_INDEX = 0;

function getAdIdFromFileName(file: any) {
  if (!file) return "";

  const fileName = file.name.split(SEPARATOR)?.[NAME_INDEX];

  return fileName;
}

export default getAdIdFromFileName;
